import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

// Inline error styling per Figma (node 16387:28129):
// FontAwesome solid `exclamation-triangle` + Roboto 12px/18px text, both `text/critical` (#e30029)
const Wrapper = styled.span`
  display: flex;
  gap: 4px;
  align-items: flex-start;
  color: #e30029;
  font-size: 12px;
  line-height: 18px;
`;

const Icon = styled.i`
  font-size: 12px;
  line-height: 16px;
  width: 16px;
  text-align: center;
  flex-shrink: 0;
`;

export interface InlineErrorProps {
  children: React.ReactNode;
  id?: string;
  'data-testid'?: string;
}

export const InlineError: FunctionComponent<InlineErrorProps> = ({
  children,
  id,
  ...props
}) => {
  return (
    <Wrapper id={id} role="alert" data-testid={props['data-testid'] ?? id}>
      <Icon className="fas fa-exclamation-triangle" aria-hidden="true" />
      <span>{children}</span>
    </Wrapper>
  );
};
